const fmkeys = {
  cf_ehash: 'ehash',
  cf_region: 'region',
  cf_source: 'source',
  cf_product: 'product',
  cf_campaign: 'campaign',
  cf_recentnote: 'recent_note',
  cf_subproduct: 'sub_product',
  cf_campaigndate: 'campaign_date',
  cf_mqlcreateddate: 'mql_created_date',
  cf_engagementstatus: 'engagement_status',
  cf_marketingcampaign: 'marketing_campaign',
  cf_fworksgenericsignupreferrer: 'Fworksgenericsignupreferrer',
  cf_parentcampaign: 'parent_campaign',
  cf_event_name: 'event_name'
};
module.exports = { fmkeys };
